// extracted by mini-css-extract-plugin
export default {"title":"da467de51d","inner_title":"_4ec9629bff","charge_btn":"bb8ca3950e"};